<template>
    <div class="page-container">
        <div class="left-box">
            <LeftPage :active="10"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="title flex justify-between">
                <div class="flex align-center">
                    <div class="icon-box">
                        <i class="iconfont icon-zhengce1"></i>
                    </div>
                    <b>科技专栏</b>
                </div>
                <div class="page-cancel" @click="$router.go(-1)">
                    <i class="icon iconfont icon-jiantouzuo1"></i>返回
                </div>
            </div>
            <el-form ref="ruleForm" v-loading="loading" :model="ruleForm" :rules="rules" class="ruleForm publish-form margin-top-sm" label-width="auto">
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="title" class="input-container" label="科技专栏标题" prop="title">
                            <el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="desc" class="input-container" label="内容描述" prop="desc">
                            <el-input v-model="ruleForm.desc" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item ref="content" class="input-container" label="科技专栏内容" prop="content">
                            <ck-basic-editor v-model="ruleForm.content"></ck-basic-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="author" class="input-container" label="作者" >
                            <el-input v-model="ruleForm.author" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="resource" class="input-container" label="来源">
                            <el-input v-model="ruleForm.resource" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="publish_time" class="input-container" label="更新时间" prop="publish_time">
                            <el-date-picker v-model="ruleForm.publish_time"
                                            placeholder="请选择" type="datetime"
                                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="is_top" class="input-container" label="参数" prop="is_top">
                            <el-switch v-model="ruleForm.is_top" active-text="置顶" :active-value="1" :inactive-value="0"></el-switch>
                            <el-switch class="margin-left-sm" v-model="ruleForm.is_tui" active-text="推荐" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
          <div class="flex justify-center">
            <el-button :loading="submit_loading && is_show == 0" class="btn max round margin-tb-sm self-center"
                       type="primary" @click="submitForm('ruleForm',0)">
              保存
            </el-button>

            <el-button v-if="id" class="btn max round margin-tb-sm self-center"
                       type="primary" @click="to">
              预览
            </el-button>

            <el-button :loading="submit_loading && is_show == 1" class="btn max round margin-tb-sm self-center"
                       type="primary" @click="submitForm('ruleForm',1)">
              发布
            </el-button>
          </div>
        </div>
    </div>
</template>

<script>

import LeftPage from "@/views/admin/pages/info/common/leftPage";
import {scrollIntoView} from "@/utils/utils";
import CkBasicEditor from "@/components/CKBasicEditor";
import {getArticleDetail, saveArticle} from "@/api/admin";

export default {
    name: "add",
    components: {CkBasicEditor, LeftPage},
    data() {
        return {
            id: '',
          is_show:0,
            ruleForm: {
                title: '',//标题
                desc: '',//描述
                cid: 5,// 模块1政策法规2通知公告3宣传信息4下载中心5科技专栏
                is_top: '',//0未置顶1置顶
                is_tui: '',//0未推荐1推荐
                status: 1,//状态0隐藏1展示
                thumb: '',//缩略图
                content: '',//内容
                files: [],//附件
                reid: '',//分类（下载）
                author: '',//作者
                resource: '',//来源
                publish_time: '',//更新时间
            },
            rules: {
                title: [
                    {required: true, message: '请输入标题', trigger: 'blur'},
                ],
                desc: [
                    {required: true, message: '请输入描述', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入内容', trigger: 'blur'},
                ],
                author: [
                    {required: true, message: '请输入作者', trigger: 'blur'},
                ],
                resource: [
                    {required: true, message: '请输入来源', trigger: 'blur'},
                ],
                publish_time: [
                    {required: true, message: '请选择更新时间', trigger: 'change'},
                ],
            },
            loading: false,
            submit_loading: false,
        }
    },
    computed: {},
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
        this.id = this.$route.query.id || ''
        if (this.id) this.init()
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getArticleDetail(this.id)
            this.ruleForm.title = _data.data.title
            this.ruleForm.desc = _data.data.desc
            this.ruleForm.is_top = _data.data.is_top
            this.ruleForm.is_tui = _data.data.is_tui
            this.ruleForm.status = _data.data.status
            this.ruleForm.thumb = _data.data.thumb
            this.ruleForm.content = _data.data.content
            this.ruleForm.files = _data.data.files ? JSON.parse(_data.data.files) : []
            this.ruleForm.reid = _data.data.reid
            this.ruleForm.author = _data.data.author
            this.ruleForm.resource = _data.data.resource
            this.ruleForm.publish_time = _data.data.publish_time
            this.loading = false
        },
        submitForm(formName,is_show) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo(is_show);
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },
        async submitInfo(is_show) {
          this.is_show = is_show
            this.submit_loading = true
            let _data = await saveArticle(
              is_show,
                this.id,
                this.ruleForm.title,
                this.ruleForm.desc,
                this.ruleForm.cid,
                this.ruleForm.is_top,
                this.ruleForm.is_tui,
                this.ruleForm.status,
                this.ruleForm.thumb,
                this.ruleForm.content,
                JSON.stringify(this.ruleForm.files),
                this.ruleForm.reid,
                this.ruleForm.author,
                this.ruleForm.resource,
                this.ruleForm.publish_time
            )
            this.submit_loading = false
            if (_data.status == 200){
                this.$message.success(_data.msg)
              if(is_show == 1){
                this.$router.go(-1)
              }
              if(!this.id && is_show == 0){
                this.id =_data.data.id
              }
            }else {
                this.$message.error(_data.msg)
            }
        },
      to(){
        const path = this.$router.resolve({
          path: '/masses/detail',
          query: {
            id: this.id,
            type:5
          }
        })
        window.open(path.href, "_blank");
      },
    }
}
</script>

<style lang="scss" scoped>

.page-container {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }

    .right-box {
        flex: 1;
        margin-left: 25px;
        width: 100%;
        height: 100%;
        min-height: calc(100vh - (173px + 159px));
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
    }

    .image {
        width: 135px;
        height: 101px;
        border-radius: 10px;
        border: 1px solid var(--grayLine);
    }
}
</style>
